export default "20260827.1 \r\n"